import { Reveal, SectionHead } from "./Reveal";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { PHONE, PHONE_LINK, EMAIL, EMAIL_LINK, WHATSAPP_LINK, MAPS_LINK } from "@/lib/site";

const CARDS = [
  ["Call", PHONE, PHONE_LINK, "Call Now", Phone, "contact-call-btn"],
  ["WhatsApp", "+91 7338323939", WHATSAPP_LINK, "WhatsApp Us", MessageCircle, "contact-whatsapp-btn"],
  ["Email", EMAIL, EMAIL_LINK, "Email Us", Mail, "contact-email-btn"],
  ["Visit", "Main Bus Stop, Gopala, Shivamogga, Karnataka – 577205, India", MAPS_LINK, "Get Directions", MapPin, "contact-directions-btn"],
];

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="noise relative overflow-hidden bg-obsidian py-24 md:py-32">
    <div className="pointer-events-none absolute inset-0">
      <div className="absolute left-1/2 top-1/2 h-[50vh] w-[70vw] -translate-x-1/2 -translate-y-1/2 rounded-full bg-royal/10 blur-[140px]" />
    </div>
    <div className="relative mx-auto max-w-6xl px-6 md:px-12">
      <SectionHead center eyebrow="Contact" title="Let's build your website." />
      <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map(([label, value, link, cta, Icon, tid], i) => (
          <Reveal key={label} delay={i * 0.1}>
            <div className="group flex h-full flex-col items-center rounded-2xl border border-white/5 bg-charcoal p-9 text-center transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:border-accent/30 hover:shadow-[0_0_40px_rgba(0,229,255,0.1)]">
              <div className="flex h-14 w-14 items-center justify-center rounded-full border border-accent/30 bg-accent/10">
                <Icon className="h-6 w-6 text-accent" strokeWidth={1.5} />
              </div>
              <p className="mt-5 font-display text-[10px] font-bold uppercase tracking-[0.3em] text-zinc-500">{label}</p>
              <p className={`mt-2 font-display text-white ${label === "Visit" ? "text-sm font-semibold leading-relaxed" : "break-all text-base font-bold md:text-lg"}`}>{value}</p>
              <a
                href={link}
                target={link.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
                data-testid={tid}
                className="mt-6 rounded-full border border-white/20 px-6 py-2.5 font-display text-[10px] font-bold uppercase tracking-[0.2em] text-white transition-[border-color,background-color,color] duration-300 hover:border-accent hover:bg-accent hover:text-ink"
              >
                {cta}
              </a>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <div className="mt-6 overflow-hidden rounded-2xl border border-white/10" data-testid="contact-map-wrap">
          <iframe
            title="Falkeen Technologies location — Main Bus Stop, Gopala, Shivamogga"
            data-testid="contact-map"
            src="https://www.google.com/maps?q=Main%20Bus%20Stop%2C%20Gopala%2C%20Shivamogga%2C%20Karnataka%20577205%2C%20India&output=embed"
            className="h-[320px] w-full grayscale-[40%] invert-[92%] hue-rotate-180 contrast-[0.9] md:h-[380px]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
